<template>
  <div class="growClub index-container">
    <div v-if="type == 1">
      <van-dropdown-menu active-color="#00AADF">
        <van-dropdown-item
          v-model="listType"
          :options="option"
          @change="changeType"
        />
        <van-dropdown-item
          title="日期筛选"
          ref="calendarBtn"
          class="calendar_btn"
        >
          <van-calendar
            v-model="show"
            class="calendar"
            type="range"
            @confirm="onConfirm"
            :max-date="new Date()"
            :min-date="new Date(1997, 0, 1)"
            :show-confirm="false"
            ref="calendar"
            :default-date="defaulDate"
            @close="closeCalendar"
          >
            <!-- :show-confirm="false" -->
            <div slot="footer" class="footer_btn">
              <van-button class="cancel_btn btn" @click="cancel"
                >重置</van-button
              >
              <van-button class="confirm_btn btn" @click="confirmDate"
                >确认</van-button
              >
            </div>
          </van-calendar>
        </van-dropdown-item>
      </van-dropdown-menu>
      <div v-if="startDate" class="range_date">
        {{ startDate + " - " + endDate }}
      </div>
    </div>
    <van-nav-bar
      :title="title"
      left-text
      left-arrow
      class="main-nav"
      @click-left="onClickLeft"
    >
      <!-- <template #right>
        <div v-if="type==1">
    <el-select v-model="roleType" @change="selectRole" placeholder="请选择" :popper-append-to-body="false" @visible-change="visibleChange">
				<el-option
					v-for="item in roleOptions"
					:key="item.value"
					:label="item.text"
					:value="item.value"
				>
				</el-option>
			</el-select>
      <div class="trangle">
				<div class="trangle_wrap">
					<img src="../../assets/images/parent-course/org-trangle.png" alt="" :class='{active:arrroStyle}' >
				</div>
			</div>
        </div>
  </template> -->
    </van-nav-bar>
    <div class="growClub_tab">
      <van-tabs
        v-if="value"
        @click="tabContentClick"
        title-active-color="#ff8340"
        title-inactive-color="#666"
        v-model="value"
        line-height="0"
        class="child-selecr-warp"
      >
        <van-tab
          v-for="(item, ind) in children"
          :key="ind"
          :title="`孩${ind + 1}：${item.studentName}`"
          :name="item.id"
        ></van-tab>
      </van-tabs>
      <div class="growClub_tab_box" v-if="type == 1">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="finishedText"
          @load="onLoad"
        >
          <div
            v-for="(item, index) in parentList"
            :key="index"
            @click="goResult(item)"
            :class="{
              growClub_tab_list_list: true,
              growClub_tab_list_parentList: item.templateId,
              isSingle: item.isSingleReport == 1,
            }"
          >
            <div class="list_imgbox" v-if="item.templateId">
              <img
                src="@/assets/images/test-center/read.png"
                alt
                v-if="item.isRead"
              />
              <img src="@/assets/images/test-center/no-read.png" alt v-else />
            </div>
            <div class="list_item">
              <!-- <div class="item_img">
                <img
                  src="@/assets/images/test-center/record.png"
                  alt
                  v-if="!item.templateId"
                />
                <img
                  src="@/assets/images/test-center/report.png"
                  alt
                  v-if="item.isSingleReport == 1"
                />
                <img
                  src="@/assets/images/test-center/reports.png"
                  alt
                  v-if="item.isSingleReport == 0"
                />
              </div> -->
              <div>
                <p class="growClub_tab_list_list_title" v-text="item.name"></p>
                <p class="growClub_tab_list_list_time">{{ item.startTime }}</p>
              </div>
            </div>
          </div>
          <div class="noData" v-if="noDataStatus">
            <img
              class="_nodata_"
              src="@/assets/images/test-center/no-data.png"
              alt
            />
            <p class="_nodatap_" style="text-align: center">
              现在还没有数据哦！
            </p>
          </div>
        </van-list>
      </div>
      <div class="growClub_tab_box" v-else>
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="finishedText"
          @load="onLoad"
        >
          <div
            class="growClub_tab_list_list growClub_tab_list_childList"
            v-for="(item, index) in childList"
            :key="index"
            @click="goResult(item)"
          >
            <div class="list_item">
              <div class="item_img">
                <img src="@/assets/images/test-center/record.png" alt />
              </div>
            </div>
            <div>
              <p class="growClub_tab_list_list_title" v-text="item.name"></p>
              <p class="growClub_tab_list_list_time">{{ item.startTime }}</p>
            </div>
          </div>
          <div class="noData" v-if="noDataStatus">
            <img
              class="_nodata_"
              src="@/assets/images/test-center/no-data.png"
              alt
            />
            <p class="_nodatap_" style="text-align: center">
              现在还没有数据哦！
            </p>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>
<script>
import { _psyRecords } from "../../api/test-center";
import { _templateList } from "../../api/test-center-temp";

import Cookies from "js-cookie";
import { verticalScreen } from "../../assets/js/vertical-screen";
import { decryptBy } from "@/assets/js/encryption";
export default {
  name: "grow-club",
  data() {
    return {
      title: "儿童成长记录",
      type: "",
      value: "",
      children: [],
      parentList: [], // 家长列表
      childList: [], // 儿童列表
      loading: true, //加载
      finished: false, // 结束加载
      current: 1, // 当前请求页码
      noDataStatus: false, //暂无数据状态
      show: true,
      listType: 0,
      startDate: "",
      endDate: "",
      defaulDate: [new Date(), new Date()],
      option: [
        { text: "全部", value: 0 },
        { text: "综合报告", value: 1 },
        { text: "单独报告", value: 2 },
        { text: "测评结果", value: 3 },
      ],
      roleType: 0,
      roleOptions: [
        { text: "家长", value: 0 },
        { text: "儿童", value: 1 },
      ],
      arrroStyle: false,
      finishedText: "",
    };
  },
  created() {
    this.type = this.$route.query.type;
    if (sessionStorage.getItem("screenData")) {
      let olddata = JSON.parse(sessionStorage.getItem("screenData"));
      this.roleType = Number(olddata.roleType);
      if (this.type == 1) {
        this.getRoles(this.roleType);
      }
      this.listType = olddata.listType;
      this.startDate = olddata.startDate;
      this.endDate = olddata.endDate;
      this.defaulDate = [
        new Date(olddata.startDate.replace(/-/g, "/")),
        new Date(olddata.endDate.replace(/-/g, "/")),
      ];
    }
    this.psyRecords();
    this.value = localStorage.getItem("childId");
    if (localStorage.getItem("children")) {
      this.children = JSON.parse(decryptBy(localStorage.getItem("children")));
    }
    if (this.type == 1 || this.type == 3) {
      // this.title = "家长成长记录";
      this.title = "历史测评";
    } else {
      this.title = "儿童成长记录";
    }
  },
  mounted() {
    verticalScreen();
  },
  beforeRouteLeave(to, from, next) {
    if (to.path == "/testType") {
      sessionStorage.removeItem("screenData");
    }
    next();
  },
  methods: {
    // 返回
    onClickLeft() {
      if (this.type == 1) {
        this.$router.push({
          path: "/testType?type=1",
        });
      } else {
        this.$router.go(-1);
      }
    },
    // 切换当前儿童
    tabContentClick(value) {
      localStorage.setItem("childId", value);
      this.value = value;
      this.psyRecords();
    },
    formatDate(date) {
      let month = "";
      let dateTime = "";
      if (date.getMonth() + 1 < 10) {
        month = "0" + (date.getMonth() + 1);
      } else {
        month = date.getMonth() + 1;
      }
      if (date.getDate() < 10) {
        dateTime = "0" + date.getDate();
      } else {
        dateTime = date.getDate();
      }
      return `${date.getFullYear()}-${month}-${dateTime}`;
    },
    closeCalendar() {
      this.$refs.calendarBtn.toggle();
      this.show = true;
    },
    // 重置
    cancel() {
      this.startDate = "";
      this.endDate = "";
      this.$refs.calendar.reset([new Date(), new Date()]);
      this.closeCalendar();
      this.psyRecords();
    },
    confirmDate() {
      if (!this.endDate) {
        this.$toast("请选择结束时间");
        return;
      }
      this.closeCalendar();
      this.current = 1;
      this.psyRecords();
    },
    onConfirm(date) {
      this.startDate = this.formatDate(date[0]);
      this.endDate = this.formatDate(date[1]);
    },
    changeType(val) {
      this.current = 1;
      // if (val == 1 || val == 2) {
      // this.getTemplates()
      // } else {
      this.psyRecords();
      // }
    },
    //获取报表
    getTemplates(records) {
      let rows = [];
      let parentId = JSON.parse(
        decryptBy(localStorage.getItem("userInfo"))
      ).userId;
      let childId = localStorage.getItem("childId");
      let data = {
        parentId: parentId,
        childId: childId,
        currentLoginUserId: parentId,
        userPlatformType: 1,
        startDate: this.startDate ? this.startDate + " 00:00:00" : "",
        endDate: this.endDate ? this.endDate + " 23:59:59" : "",
      };
      _templateList(data)
        .then((res) => {
          if (res.code == 200) {
            if (res.data && res.data.length > 0) {
              let reports = [];
              let singleReport = [];
              let isReadList = [];
              let notReadList = [];
              let data = this.dataSort(res.data);
              data.forEach((each, index) => {
                if (each.isRead) {
                  // 已读
                  isReadList.push(each);
                } else {
                  // 未读
                  notReadList.push(each);
                }
                if (each.isSingleReport == 1) {
                  // 单报告
                  singleReport.push(each);
                } else {
                  // 复合报告
                  reports.push(each);
                }
                each.name = each.title;
                each.startTime = each.createTime;
                let domParser = new DOMParser();
                let document = domParser.parseFromString(
                  each.title,
                  "text/html"
                );
                each.name = document.body.innerText;
              });

              let rowList = "";
              if (this.listType === 0) {
                rowList = notReadList.concat(
                  this.dataSort(isReadList.concat(records))
                );
              } else if (this.listType === 1) {
                let isReadReports = [];
                let notReadReports = [];
                reports.forEach((each, index) => {
                  if (each.isRead) {
                    isReadReports.push(each);
                  } else {
                    notReadReports.push(each);
                  }
                });
                rowList = notReadReports.concat(isReadReports);
              } else if (this.listType === 2) {
                let isReadReports = [];
                let notReadReports = [];
                singleReport.forEach((each, index) => {
                  if (each.isRead) {
                    isReadReports.push(each);
                  } else {
                    notReadReports.push(each);
                  }
                });
                rowList = notReadReports.concat(isReadReports);
              }
              rows = rowList;
            } else {
              if (this.listType == 1 || this.listType == 2) {
                rows = [];
              } else {
                rows = records;
              }
            }
          }
          this.getPage(rows);
        })
        .catch((err) => {
          throw err;
        });
    },
    dataSort(data) {
      let rows = data.sort((a, b) => {
        let atime = new Date(a.startTime).valueOf();
        let btime = new Date(b.startTime).valueOf();
        return btime - atime;
      });
      return rows;
    },
    // 获取成长记录
    psyRecords() {
      let resourceFrom;
      let parentId = JSON.parse(
        decryptBy(localStorage.getItem("userInfo"))
      ).userId;
      let childId = localStorage.getItem("childId");
      let pageSize = 10;
      if (this.type == 1) {
        if (this.roleType == 1) {
          resourceFrom = 2;
        } else {
          resourceFrom = 3;
        }
        pageSize = 10000;
      } else {
        resourceFrom = 2;
        pageSize = 10;
      }
      _psyRecords({
        currentPage: this.current,
        pageSize: pageSize,
        queryData: {
          childId: childId,
          parentId: parentId,
          psyToken: Cookies.get("token"),
          resourceFrom:
            this.type == 3
              ? 4
              : JSON.parse(decryptBy(localStorage.getItem("userInfo")))
                  .userType == "PARENT"
              ? 3
              : 4,
          startTime: this.startDate,
          endTime: this.endDate,
        },
      }).then((res) => {
        if (res && res.code == 200) {
          // this.childList = [];
          // this.parentList = [];
          let rows = [];
          // 家长
          if (this.type == 1) {
            // let
            let records = res.data.records;
            if (records.length > 0) {
              this.finishedText = "没有更多了";
            } else {
              this.finishedText = "";
            }
            records.forEach((item) => {
              let domParser = new DOMParser();
              let document = domParser.parseFromString(item.name, "text/html");
              item.name = document.body.innerText;
            });

            //if (this.current == 1 && this.listType != 3 && this.roleType == 0) {
            // 报告
            // this.getTemplates(records)
            //} else {
            rows = records;
            this.getPage(rows);
            //}
          } else {
            rows = res.data.records; //请求返回当页的列表
            if (rows.length > 0) {
              this.finishedText = "没有更多了";
            } else {
              this.finishedText = "";
            }
            this.getPage(rows);
          }
        } else {
          this.$toast(res.message);
          this.finished = true;
        }
      });
    },
    getPage(rows) {
      this.loading = false;
      if (rows.length < 10) {
        // 加载结束
        this.finished = true;
      }
      if (this.type == 1) {
        // 将新数据与老数据进行合并
        if (this.current == 1) {
          this.parentList = rows;
        } else {
          this.parentList = [...this.parentList, ...rows];
        }
        // this.parentList = this.parentList.sort((a, b) => {
        //   let atime = (new Date(a.startTime)).valueOf()
        //   let btime = (new Date(b.startTime)).valueOf()
        //   return btime - atime
        // })
        if (this.parentList.length > 0) {
          this.noDataStatus = false;
        } else {
          this.noDataStatus = true;
        }
      } else {
        // 将新数据与老数据进行合并
        if (this.current == 1) {
          this.childList = rows;
        } else {
          this.childList = [...this.childList, ...rows];
        }
        if (this.childList.length > 0) {
          this.noDataStatus = false;
        } else {
          this.noDataStatus = true;
        }
      }
    },
    // 查看测评结果
    goResult(item) {
      let url = "";
      let id = "";
      let status = false;
      let saveData = JSON.stringify({
        startDate: this.startDate,
        endDate: this.endDate,
        listType: this.listType,
        roleType: this.roleType,
      });
      sessionStorage.setItem("screenData", saveData);
      if (item.id) {
        url = "/template";
        id = item.id;
        status = item.isRead ? 1 : 0;
      } else {
        url = "/result";
        id = item.resultId;
      }
      if (this.type == 2 && !item.isTransResult) {
        return;
      }
      this.$router.push({
        path: url,
        query: {
          resultId: id,
          status: status,
        },
      });
    },
    getRoles(value) {
      if (value == 0) {
        this.option = [
          { text: "全部", value: 0 },
          { text: "综合报告", value: 1 },
          { text: "单独报告", value: 2 },
          { text: "测评结果", value: 3 },
        ];
      } else {
        this.option = [
          { text: "全部", value: 0 },
          { text: "测评结果", value: 3 },
        ];
      }
    },
    // 选择家长/儿童
    selectRole(value) {
      this.getRoles(value);
      this.current = 1;
      this.psyRecords();
    },
    // 控制下拉框箭头的样式
    visibleChange() {
      this.arrroStyle = !this.arrroStyle;
    },
    // 滑动加载
    onLoad() {
      this.current++;
      this.psyRecords();
    },
  },
};
</script>
<style lang="scss" scoped>
$active: "../../assets/images/parent-course/active.png";
.growClub {
  padding-top: 46px;
  height: 100%;
  .range_date {
    text-align: center;
    color: #666666;
    background-color: #fbfafc;
  }
  .main-nav {
    position: fixed;
    width: 100%;
    top: 0;
    ::v-deep .el-select {
      width: 80px;
      height: 26px;
    }
    ::v-deep .el-input__suffix {
      display: none;
    }
    ::v-deep .el-input__inner {
      width: 80px;
      height: 26px;
      border: none;
      box-shadow: 0px 1px 4px 0px rgba(203, 203, 203, 0.5);
      border-radius: 6px;
      color: var(--font-size-color);
      line-height: 26px;
    }
    ::v-deep .el-select .el-input .el-select__caret {
      color: var(--font-size-color);
    }
    ::v-deep .el-select-dropdown__item.selected {
      color: var(--font-size-color);
    }
    ::v-deep li.el-select-dropdown__item.selected.hover {
      height: 22px;
      line-height: 22px;
    }
    ::v-deep li.el-select-dropdown__item.selected {
      height: 22px;
      line-height: 22px;
    }
    .trangle {
      position: absolute;
      right: 30%;
      top: 44%;
      .trangle_wrap {
        width: 10px;
        height: 7px;
        img {
          transition: all 0.2s linear;
          width: 100%;
          height: 100%;
          &.active {
            transform: rotate(180deg);
          }
        }
      }
    }
  }
  ::v-deep .van-tab {
    -webkit-flex: unset !important;
    flex: unset !important;
  }
  .growClub_tab {
    margin-top: 12px;
    padding: 0 20px 10px 20px;
    // overflow-y: auto;
    height: calc(100% - 69px);
    ::v-deep .van-tabs__nav {
      background-color: transparent;
      overflow: auto;
      .van-tab {
        // flex-grow: 0;
        // flex-grow: 0;
        // flex-shrink: 1;
        // flex-basis: auto;
        flex: unset !important;
        margin-right: 4px;
        .van-tab__text {
          padding: 9px 20px;
          background: #aef6f8;
          color: #161515;
          font-size: 16px;
          border-radius: 999px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          -o-text-overflow: ellipsis;
        }
      }
      .van-tab--active {
        .van-tab__text {
          color: #fff;
          background: var(--btn-backgruond-color);
        }
      }
    }
    .growClub_tab_box {
      margin-top: 17px;
      .growClub_tab_list_list {
        width: 335px;
        height: 80px;
        padding: 18px 20px;
        margin-bottom: 8px;
        display: flex;
        align-items: center;
        // justify-content: center;
        position: relative;
        background-color: #fff;
        border-radius: 8px;
        box-sizing: border-box;
        .list_imgbox {
          position: absolute;
          right: 0;
          top: 15px;
          img {
            width: 56px;
            height: 27px;
          }
        }
        .list_item {
          display: flex;
          .item_img {
            img {
              width: 50px;
              height: 50px;
              margin-right: 20px;
            }
          }
        }
        .growClub_tab_list_list_title {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 500;
          color: #2e4344;
          line-height: 20px;
          width: 292px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .growClub_tab_list_list_time {
          margin-top: 8px;
          font-weight: 400;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #949c9d;
        }
      }
      .growClub_tab_list_parentList,
      .growClub_tab_list_childList {
        // background: url(./../../assets/images/test-center/parent-bg.png);
        // background-size: cover;
        // background-color: #fffcf6;
      }
      .isSingle {
        background-color: #f6faff !important;
      }
      // .growClub_tab_list_childList {
      //   background: url(./../../assets/images/test-center/child-bg.png);
      //   background-size: cover;
      //   text-align: center;
      // }
    }
    .noData {
      padding: 30px;
      text-align: center;
    }
  }
}
// ::v-deep .van-icon {
//   color: #000;
// }
// .calendar {
//   margin-top: 98px;
//   height: 490px;
//   ::v-deep .van-calendar__header-subtitle {
//     display: none;
//   }
//   ::v-deep .van-calendar__body {
//     overflow: hidden;
//     height: 394px;
//   }
//   ::v-deep .van-popup__close-icon {
//     display: none;
//   }
// }
.calendar_btn {
  ::v-deep .van-overlay {
    background-color: transparent;
  }

  ::v-deep .van-calendar {
    .van-calendar__day--start,
    .van-calendar__day--end {
      background-color: var(--font-size-color);
    }
    .van-calendar__day--middle {
      color: var(--font-size-color);
    }
  }
  .footer_btn {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    .btn {
      width: 48%;
      border-radius: 4px;
    }
    .cancel_btn {
      color: var(--font-size-color);
      border-color: var(--font-size-color);
    }
    .confirm_btn {
      background: var(--btn-backgruond-color);
      color: #fff;
    }
  }
}
::v-deep .van-popup {
  .van-overlay {
    background-color: rgba(0, 0, 0, 0.7);
  }
}
::v-deep .van-dropdown-menu__bar--opened {
  z-index: 0;
}
// ::v-deep .van-dropdown-menu__title--active {
//   color: #2c2c30;
// }
</style>
